import type { ActionsTakenType } from "./ActionsTakenWidget.types"

// Issue actions, then ticketing, then notifications; alphabetical by title within each group
export const ACTIONS_TAKEN_TYPES: ActionsTakenType[] = [
  "dismiss",
  "reopen",
  "label",
  "asana_task",
  "azure_boards_issue",
  "github_issue",
  "jira_issue",
  "slack_message",
  "webhook"
]

// Tiles are wrapped in two groups so a narrow row breaks 5 + 4 rather than 8 + 1, 7 + 2 or 6 + 3
export const ACTIONS_TAKEN_TILE_GROUPS: ActionsTakenType[][] = [
  ACTIONS_TAKEN_TYPES.slice(0, 5),
  ACTIONS_TAKEN_TYPES.slice(5)
]
